var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _seq;
import { Vec3D } from "./vec3d";
export const HandSequenceChoices = [
    ["Inside throws", "(10)(32.5)."],
    ["Backcrosses", "(-10,0,-50)(20)."],
    ["Backshoulders", "(25,0,-50)(0)."],
    ["Backcatches", "(0)(25,0,-50)."],
    ["Outside throws", "(32.5)(10)."],
    ["Mills Mess", "(-30)(2.5).(30)(-2.5).(-30)(0)."],
    ["Half shower", "(32.5)(10).(10)(32.5)."],
    ["Windmill", "(-20)(25).(25)(-20)."],
    ["Shower", "(25)(12.5).(12.5)(25)."],
];
HandSequenceChoices.sort((a, b) => a[0].localeCompare(b[0]));
export const HandSequenceMap = {};
HandSequenceChoices.forEach((s) => (HandSequenceMap[s[0]] = s[1]));
export const DefaultHandSequenceName = "Inside throws";
function parseHandCoor(s) {
    if (s.charAt(0) !== "(" || s.charAt(s.length - 1) !== ")") {
        throw new Error();
    }
    s = s.substring(1, s.length - 1);
    const parts = s.split(",");
    if (parts.length > 3) {
        throw new Error();
    }
    const fparts = parts.map((p) => parseFloat(p));
    while (fparts.length < 3) {
        fparts.push(0);
    }
    return new Vec3D(fparts[0], fparts[1], fparts[2]);
}
function parseHandSequenceBeats(s) {
    const coor = "\\(((-?[0-9]+(.[0-9]+)?(,-?[0-9]+(.[0-9]+)?){0,2}))\\)";
    const re = new RegExp(new RegExp(`(${coor})(${coor})\\.`, "g"));
    let idx = 0;
    const ret = [];
    for (const m of s.matchAll(re)) {
        if (!m || m.length < 8)
            throw new Error();
        if (m.index !== idx) {
            throw new Error();
        }
        idx += m[0].length;
        const thrw = parseHandCoor(m[1]);
        const ctch = parseHandCoor(m[7]);
        ret.push([thrw, ctch]);
    }
    if (idx !== s.length) {
        throw new Error();
    }
    return ret;
}
export function parseHandSequence(s) {
    const ret = [[], []];
    const beats = parseHandSequenceBeats(s);
    let idx = 0;
    while (true) {
        const h = idx % 2;
        const beatIdx = idx % beats.length;
        const beat = beats[beatIdx];
        if (h === 0 && beatIdx === 0 && ret[h].length > 0) {
            break;
        }
        ret[h].push(beat[0]);
        ret[h].push(beat[1]);
        idx++;
    }
    return ret;
}
export class SequenceHandMovement {
    constructor(seq) {
        _seq.set(this, void 0);
        __classPrivateFieldSet(this, _seq, seq);
    }
    length() {
        return __classPrivateFieldGet(this, _seq)[0].length;
    }
    getPosition(idx, j, h) {
        let seq = __classPrivateFieldGet(this, _seq)[h % __classPrivateFieldGet(this, _seq).length];
        let l = seq.length;
        let i;
        if (idx >= 0) {
            i = idx % l;
        }
        else {
            i = (l + (idx % l)) % l;
        }
        let pos = seq[i];
        pos = pos.clone();
        if (h % 2) {
            // Right, so flip
            pos.x = -pos.x;
        }
        pos.x *= -1;
        return pos;
    }
}
_seq = new WeakMap();
